import { render, staticRenderFns } from "./DoubleCtaSection.vue?vue&type=template&id=b5a70ee8&scoped=true&"
import script from "./DoubleCtaSection.vue?vue&type=script&lang=js&"
export * from "./DoubleCtaSection.vue?vue&type=script&lang=js&"
import style0 from "./DoubleCtaSection.vue?vue&type=style&index=0&id=b5a70ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a70ee8",
  null
  
)

export default component.exports